export enum ExpandModes {
  default = 'default',
  expand = 'expand',
  collapse = 'collapse',
  off = 'off',
}
